import { t } from "shared/localization/localization";

export enum TabIdList {
  routes = "routes",
  airline = "airline",
}

export const eventDescriptionPlaceholder = t("Undefined Event");
